<template>
  <article class="trainers">
    <section class="trainers__header_sublocation section_first_child mt-0">
      <div class="trainers__header_sublocation--back">
        <img
        v-if="getUserType() !== 'Counter'"
        src="https://karrottsportlife.s3-us-west-2.amazonaws.com/profile_icons/icono-volver.svg" alt="" @click="$router.push({name: 'access'})">
        <p
        v-if="getUserType() !== 'Counter'"
        @click="$router.push({name: 'access'})">Volver a Locaciones</p>
      </div>

      <div class="trainers__header_sublocation--today">
        <div
          style="cursor: pointer"
          class="trainers__header_sublocation--time_zone"
          v-if="(getUserType()=='Admin'||getUserType()=='Counter'||getUserType()=='Counter_offline') && location_name == 'Feria'"
          @click="show_modal_reward_user=true">
          <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/profile_icons/man-avatar.svg" alt="">
          <p>INVITACIÓN FERIA</p>
        </div>
        <div
          style="cursor: pointer"
          class="trainers__header_sublocation--time_zone"
          v-if="(getUserType()=='Admin'||getUserType()=='Counter'||getUserType()=='Counter_offline') && getCompany().access.dynamic_invitations"
          @click="active_modal_invitation=true">
          <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/profile_icons/man-avatar.svg" alt="">
          <p>ENVIAR CORTESIA</p>
        </div>
        <div v-if="location_time_zone !== timeZoneLocal" class="trainers__header_sublocation--time_zone">
          <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/watch.svg" alt="">
          <p>Zona horiaria de {{ time_zone }}, {{ country }} (GTM{{ gtm }})</p>
        </div>
        <v-hover>
          <div
            @click="findSublocations()"
            slot-scope="{ hover }"
            class="accessIndex__reload--container"
            :class="hover?'accessIndex__interaction--hover':''">
            <img src="@/assets/img/icons/refresh-icon.svg" alt="">
          </div>
        </v-hover>
        <div v-if="location_type !== 'Reserva Sublocacion'">
          <div class="trainers__header_sublocation--current_day">{{ day_name }}</div>
          <app-single-date-picker
            :date_text="day_today !== '' ? day_today : today()"
            @filterQuery="filterQuery"
            ></app-single-date-picker>
        </div>
      </div>
    </section>
    <section class="trainers__header_sublocation">
      <div>
        <div class="trainers__header_sublocation--content_title">
          <h1>{{location_name}}</h1>
        </div>
        <div class="trainers__header_sublocation--div_quotas">
          <p>CUPOS DISPONIBLES</p>
          <span>{{ max_spaces - get_spaces }}</span>
        </div>
      </div>
      <div>
        <!-- datepicker for export -->
        <app-date-picker-export v-if="location_type !== 'Reserva Sublocacion'"
          @sendDates="exportExcel(false ,$event)">
        </app-date-picker-export>
        <div v-if="getUserType() !='Counter'">
          <div class="trainers__header_sublocation--user_type_buttom" v-if="location_type !== 'Reserva Sublocacion'"
            @click="$router.push({name: 'location_access_user', params: {id: parmsLocationId, location_name: location_name} })"
            >
            <p>VER LISTADO DE USUARIOS</p>
            <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/profile_icons/man-avatar.svg" alt="">
          </div>
          <div class="trainers__header_sublocation--user_type_buttom" v-else
            @click="$router.push({name: 'location_bookings', params: {id: parmsLocationId, location_name: location_name} })"
            >
            <p>VER LISTADO DE RESERVAS</p>
            <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/profile_icons/man-avatar.svg" alt="">
          </div>
        </div>

        <div class="" v-if="location_type !== 'Reserva Sublocacion'">
          <div class="trainers__header_sublocation--user_inside">
            <p>Usuarios adentro</p>
          </div>
          <div class="trainers__header_sublocation--count_total">
            <div>
              <p>PERSONAS</p>
              <p></p>
              <p>CUPOS</p>
            </div>
            <div>
              <span>{{ current_population }}</span>
              <span>/</span>
              <span>{{ max_spaces }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <hr class="trainers__line">
    <section class="classes__container">
      <section
        v-if="sublocations.length>0"
        class="data_card"
        v-for="sublocation in sublocations"
        :key="sublocation.id">
        <div class="data_card__info_sublocation">
          <div class="data_card__info_sublocation--info_top">
            <div v-if="
              validateQuota(mapCurrentPopulation(sublocation.id),sublocation.attributes.sublocation_schedule[day_name_english.toLowerCase()].max_spaces)"
              class="type_buttom type_buttom__blue">
              CUPOS LIBRES
            </div>
            <div v-else class="type_buttom type_buttom__green">
              CUPO LLENO
              <span v-if="mapNotCometOut(sublocation.id)>0">{{ mapNotCometOut(sublocation.id) }}</span>
            </div>

            <div
              v-if="getUserType() !== 'Counter' && location_type === 'Reserva Sublocacion'"
              class="data_card__info_sublocation--calendar"
              @click="$router.push({name: 'calendar_booking', params: { id: sublocation.id, location_id: parmsLocationId, sublocation_name: sublocation.attributes.name } })">
              <div>
                <v-icon>event</v-icon>
              </div>
            </div>
            <p v-else>
              {{ mapCurrentPopulation(sublocation.id)}}/{{sublocation.attributes.sublocation_schedule[day_name_english.toLowerCase()].max_spaces}}
            </p>
          </div>
          <p class="data_card__info_sublocation--info_center">
            {{sublocation.attributes.name}}
            <!-- .attributes.name.charAt(0).toUpperCase()+ segment.attributes.name.slice(1) -->
          </p>
          <div
            class="data_card__info_sublocation--info_buttom"
            v-if="location_type !== 'Reserva Sublocacion'"
            @click="$router.push({name: 'reservation', params: {location_id: parmsLocationId,location_name: location_name,
              id: sublocation.id, sublocation_name: sublocation.attributes.name,
              max_spaces: sublocation.attributes.sublocation_schedule[day_name_english.toLowerCase()].max_spaces
            }})"
            >
            <u>Ver más información</u>
            <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/profile_icons/icono-agregar.svg" alt="">
          </div>
          <div v-else class="data_card__info_sublocation--info_buttom"></div>

          <div
            v-if="getUserType() !== 'Counter'"
            class="data_card__info_sublocation--edit_buttom"
            @click="$router.push({name: 'sublocation_edit', params: {id: sublocation.id}})">
            <div >
              <v-icon>edit</v-icon>
            </div>
          </div>
          <div
            class="data_card__info_sublocation--qr"
            style="position: absolute; left: 24px; bottom:5px; cursor: pointer"
            @click="selectLocation(sublocation)">
            <qr-icon ></qr-icon>
          </div>
        </div>
      </section>
      <section class="data_card">
        <div class="data_card__info_sublocation">
          <div class="data_card__info_sublocation--info_top">
            <div class="type_buttom"></div>
            <p>
              {{ current_invited_clients }}
            </p>
          </div>
          <p class="data_card__info_sublocation--info_center">
            Invitados
          </p>
          <div class="data_card__info_sublocation--info_buttom"
            @click="$router.push({name: 'reservation', params: {location_id: parmsLocationId,location_name: location_name,
              id: 0, sublocation_name: 'Invitados',
              max_spaces: 0
            }})"
            >
            <u>Ver más información</u>
            <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/profile_icons/icono-agregar.svg" alt="">
          </div>
        </div>
      </section>
      <section class="data_card" @click="$router.push({name: 'sublocation_new', params: {id:$route.params.id}})">
       <!--  <div class="data_card__buttons">
          <div class="data_card__buttons--container">
            <div
              class="data_card__buttons--edit--add"
              style="top: 22px;position: absolute;right: -5px;"
            >
              <v-icon>add</v-icon>
            </div>
          </div>
        </div> -->
        <div
          v-if="getUserType() !== 'Counter'"
          class="data_card__info_sublocation_add" style="cursor:pointer">
          <p class="data_card__info_sublocation_add--info_center" style="font-size: 15px;">
            Crear Sublocación
            <img src="https://karrottsportlife.s3-us-west-2.amazonaws.com/profile_icons/icono-agregar.svg" alt="">
          </p>
        </div>
      </section>
    </section>
    <modal-invitation
      @handleCancelModalInvitation="cancelModalInvitation"
      v-if="active_modal_invitation">
    </modal-invitation>
    <modal-reward-user
      @handleCancelModalRewardUser="cancelModalRewardUser"
      v-if="show_modal_reward_user">
    </modal-reward-user>
    <qr-modal
      v-if="show_qr_modal"
      :qr_text="location_selected"
      :location_name="sublocation_name"
      @closeQrModal="resetQrModal()"></qr-modal>
  </article>
</template>

<script>
import ModalInvitation from '../../../views/invitations/ModalInvitation'
import ModalRewardUser from '../../../views/invitations/ModalRewardUser'

export default {
  data(){
    return{
      sublocations:[],
      sublocation_selected: null,
      sublocation_name: '',
      location_name: '',
      location_type: '',
      max_spaces: '',
      get_spaces: '',
      day_today: '',
      day_name: '',
      day_name_english: '',
      current_population: 0,
      population: [],
      myRequestInterval:null,
      time_zone: '',
      country: '',
      gtm: '',
      location_time_zone: '',
      active_modal_invitation: false,
      show_modal_reward_user: false,
      current_invited_clients: 0,
      location_selected:'',
      show_qr_modal: false
    }
  },


  computed:{
    lastView(){
      if(this.$route.path.includes("locations")){
        return "locations"
      }
      return "access"
    },
    parmsLocationId: function() {
      return this.$route.params.id;
    },
    timeZoneLocal: function(){
      let resolvedOptions = Intl.DateTimeFormat().resolvedOptions()
      return resolvedOptions.timeZone
    }
  },
  components: {
    'modal-invitation': ModalInvitation,
    'modal-reward-user': ModalRewardUser
  },
  methods:{
    selectLocation(object){
      this.location_selected = object.id;
      this.sublocation_name = object.attributes.name;
      this.show_qr_modal = true;
    },
    resetQrModal(){
      this.show_qr_modal = false;
      this.location_selected = null;
    },
    deleteLocation(id){
      try {
        this.$http.delete('locations/'+id,
        {headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          for (var i = 0; i < this.locations.length; i++) {
            if(this.locations[i].id == id){
              this.locations.splice(i, 1)
            }
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findSublocations(){
      var params = this.$route.params;
      /* let date = new Date();
      let current_datetime = date.toLocaleString();   */
      /* console.log('this.current_datetime() ',  this.current_datetime()) */
      try {
        this.$http.get('sublocations',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params:{
            location_id: params.id,
            day_name: this.day_name_english,
            current_datetime: this.current_datetime()
          }
        })
        .then(function(response){
          console.log(response)
          this.sublocations = response.body.data
          this.location_name= response.body.meta.location_name
          this.location_type= response.body.meta.location_type
          this.max_spaces= response.body.meta.max_spaces
          this.get_spaces= response.body.meta.get_spaces
          this.location_time_zone = response.body.meta.time_zone
          this.time_zone=response.body.meta.time_zone.substring(response.body.meta.time_zone.indexOf('/') + 1,response.body.meta.time_zone.length).replace(/[_]/g,' ')
          this.country=response.body.meta.country
          this.gtm=response.body.meta.gtm.replace(/[0]/g,'')
          this.current_population = (response.body.meta.current_population)
          this.population = response.body.meta.sublocation_get_population_quantity
          this.current_invited_clients = response.body.meta.invited_clients_quantity
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          // if(typeof response.body.errors[0].details != "object"){
          //   alert(response.body.errors[0].details);
          // }else{
          //   let message = []
          //   for(var key in response.body.errors[0].details){
          //     message.push(response.body.errors[0].details[key])
          //   }
          //   alert(message);
          // }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    currentToday: function(d_parms){
      let weekday = new Array(7);
      weekday[0] = "DOMINGO";
      weekday[1] = "LUNES";
      weekday[2] = "MARTES";
      weekday[3] = "MIERCOLES";
      weekday[4] = "JUEVES";
      weekday[5] = "VIERNES";
      weekday[6] = "SABADO";
      let n = weekday[d_parms];
      let date =  new Date();
      let dd = this.changeFormatDate(this.day_today);
      if (date.getDate() === dd.getDate() && date.getMonth() === dd.getMonth() && date.getFullYear() === dd.getFullYear()){
        n = 'HOY'
      }
      /* this.changeFormatDate(); */
      this.day_name = n;
      return n;
    },
    currentTodayEnglish: function(day){
      let weekday = new Array(7);
      weekday[0] = "Sunday";
      weekday[1] = "Monday";
      weekday[2] = "Tuesday";
      weekday[3] = "Wednesday";
      weekday[4] = "Thursday";
      weekday[5] = "Friday";
      weekday[6] = "Saturday";
      let n = weekday[day];
      this.day_name_english = n;
      return n;
    },
    filterQuery: function(date){
      this.day_today = date;
      let day = this.changeFormatDate(date);
      this.currentToday(day.getDay());
      this.currentTodayEnglish(day.getDay());
      this.findSublocations();
    },
    changeFormatDate(date) {
      /* 29/05/2020 to 2020-05-29 */
      let new_date = '';
      new_date = date.substring(6,10) + '-' + date.substring(3,5) + '-' + date.substring(0,2) + 'T00:00:00';
      new_date = new Date(Date.parse(new_date));
      return new_date
    },
    today: function() {
      let date =  new Date();
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
          dd = '0' + dd;
      }
        if (mm < 10) {
          mm = '0' + mm;
      }
      let date_complete = dd + '/' + mm + '/' + yyyy;
      this.day_today = date_complete;
      this.currentToday(date.getDay());
      this.currentTodayEnglish(date.getDay());
      return date_complete;
    },
    current_datetime: function(){
      let date = new Date().toISOString();
      /* let dateStr =
        date.getFullYear() + "-" +
        ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
        ("00" + date.getDate()).slice(-2) + " " +
        ("00" + date.getHours()).slice(-2) + ":" +
        ("00" + date.getMinutes()).slice(-2) + ":" +
        ("00" + date.getSeconds()).slice(-2);
        return dateStr */
        return date.replace(/[ZT]/g,' ')
    },
    mapCurrentPopulation: function(params_sublocation_id){
      let value = 0
      let sublocacion = this.population.find(e => e.sublocation_id === Number(params_sublocation_id) )
      if (sublocacion !== undefined ){
        let quantity = sublocacion.quantity.find(q => q.name==="current_population")
        if (quantity !== undefined){
          value = quantity.count
        }
      }
      return value
    },
    mapNotCometOut: function(params_sublocation_id){
      let value = 0
      let sublocacion = this.population.find(e => e.sublocation_id === Number(params_sublocation_id) )
      if (sublocacion !== undefined ){
        let quantity = sublocacion.quantity.find(q => q.name==="not_comet_out")
        if (quantity !== undefined){
          value = quantity.count
        }
      }
      return value
    },
    validateQuota(popultaion,quota){
      let value = false;
      if (popultaion < quota){
        value = true;

      }
      return value
    },
    exportExcel(reload = false, dates){
      // Fechas seleccionadas
      var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: ''}
      var first_date_element = object.date_from
      var last_date_element = object.date_to
      var firstDate = null;
      var secondDate = null;
      if(first_date_element!=null && last_date_element!=null && !reload){
        if(first_date_element !="" || last_date_element !=""){
          secondDate = new Date(last_date_element);
          firstDate = new Date(first_date_element);
          secondDate.setHours(23,59,59);
          secondDate.setDate(secondDate.getDate());
          firstDate.setHours(0,0,0,0);
          firstDate.setDate(firstDate.getDate());

          firstDate = this.$moment(firstDate).format("YYYY-MM-DD")
          secondDate = this.$moment(secondDate).format("YYYY-MM-DD")
        }
      }

      this.$http.get('app/locations/export_bookings_report',
        {
          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken(),
          },
          params:{
            location_id: this.$route.params.id,
            start_date: firstDate,
            end_date: secondDate,
          },
          responseType: 'ArrayBuffer'
        }).then(function(response){
          const b64Data = response.body
          const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

          // function to decode a Base64-encoded string into a new string with a character for each byte of the binary data.
          const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
              const slice = byteCharacters.slice(offset, offset + sliceSize);

              const byteNumbers = new Array(slice.length);
              for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
              }

              const byteArray = new Uint8Array(byteNumbers);
              byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, {type: contentType});
            return blob;
          }

          const blob = b64toBlob(b64Data, contentType);
          const url = URL.createObjectURL(blob);

          const link = document.createElement('a')
          link.href = url
          var file_name = ''
          if(firstDate != null && secondDate != null){
            file_name = "Reporte "+this.location_name+" desde "+ firstDate +" hasta "+ secondDate +".xlsx"
          }else{
            file_name = "Reporte "+this.location_name+" - "+this.day_today+".xlsx"
          }
          link.setAttribute('download', file_name)
          document.body.appendChild(link)
          link.click()

          if(response.body.meta != undefined &&
              response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
                response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined &&
                response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
    },
    cancelModalInvitation(){
      this.active_modal_invitation = false;
    },
    cancelModalRewardUser(){
      this.show_modal_reward_user = false;
    }
  }, /* closed methods */
  mounted(){
    this.findSublocations();
    var vm = this;
    this.myRequestInterval=setInterval(function(){
        /* Actualiza cada 5 minutos */
        vm.findSublocations();
    },300*1000);
  },
  beforeDestroy(){
    clearInterval(this.myRequestInterval)
  },

}
</script>



// WEBPACK FOOTER //
// src/components/views/locations/sublocations/Index.vue